import { format, isToday } from 'date-fns';
import { parseToDate } from '../../../utils/date';

const formatDateTime = (date: string, showOnlyTimeForToday?: boolean) => {
    // Parse date string to Date object, handling UTC conversion for Safari compatibility
    const dateObj = parseToDate(date);

    if (showOnlyTimeForToday && isToday(dateObj)) {
        return format(dateObj, 'p'); // 12:59 PM
    }

    return format(dateObj, 'PP'); // Oct 11, 2022
};

/** Long form with time — "Oct 11, 2022, 12:59 PM". */
export const formatDateTimeLong = (date: string) =>
    format(parseToDate(date), 'MMM d, yyyy, h:mm a');

export default formatDateTime;
